






























































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import ChangeRadio from '@/components/changeRadio/changeRadio.vue';
import { institutionServer } from '@/api/installServer';

@Component({
  components: { ChangeRadio },
})
export default class Tree extends Vue {
  private visible = false;
  private input: any = '';
  private checkedText: any = [];
  private cities: any = []; // 展示可选的数据

  private created() {}

  private mounted() {}

  private getList(val?: any) {
    institutionServer
      .getAllDeptStaff({
        name: val ? val : null,
      })
      .then((res: any) => {
        this.cities = res.data.deptList;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * 打开窗口
   */
  private async showDialog(data: any) {
    this.getList();
    if (data) {
      setTimeout(() => {
        data.map((res: any) => {
          this.cities.map((re: any) => {
            if (res.objId === re.id) {
              (this.$refs.multipleTable as any).toggleRowSelection(re, true);
            }
          });
        });
      }, 100);
    }

    this.visible = true;
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.visible = false;
    this.checkedText = [];
    (this.$refs.multipleTable as any).clearSelection();
  }

  private save() {
    const ListOne: any = []; // 存储id
    let ListTwo: any = []; // 去重之后的数组
    this.checkedText.map((res: any) => {
      ListOne.push({
        objId: res.id,
        objName: res.name,
        type: 'department',
      });
    });
    ListTwo = this.unique(ListOne);
    this.$emit('getCheckNode', ListTwo);
    this.hideDialog();
  }

  /**
   @description: 选中的值
   @author: cxf
   @update: cxf 2021/7/12 14:04
   **/
  private handleSelectionChange(val: any) {
    this.checkedText = val;
  }

  /**
         @description: 数组去重
         @author: cxf
         @update: cxf 2021/7/26 16:20
         **/
  public unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i] === arr[j] || arr[i] === undefined || arr[j] === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  /**
   @description: 对已选的数据进行删除
   @author: cxf
   @update: cxf 2021/7/12 15:15
   **/
  private indexDelete(arr: any, index: any) {
    arr.splice(index, 1);
    (this.$refs.multipleTable as any).clearSelection();
    if (arr) {
      arr.forEach((row: any) => {
        (this.$refs.multipleTable as any).toggleRowSelection(row);
      });
    } else {
      (this.$refs.multipleTable as any).clearSelection();
    }
    this.$forceUpdate();
  }

  @Watch('input')
  private searchDept(val: any) {
    this.getList(val);
  }
}
